export const RequestInit = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json'
    },
    credentials: "include",
};
export const RequestInitPost = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    credentials: "include",
};
export const RequestInitWithBody = (bodyData:{body:{}, type: string}) => {
    return(
        {
            method: bodyData.type,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify(bodyData.body)
        }

    )

}